import { TransformDate } from '../../../shared/decorators/transform-date.decorator';
import { TransformInt } from '../../../shared/decorators/transform-int.decorator';
import { FileDto } from '../../../shared/modules/files/dtos/file.dto';
import { ReportJobStatusEnum } from '../enums/report-job-status.enum';

/**
 * Create report job DTO
 */
export class CreateReportJobDto {
	@TransformInt()
	reportId!: number;
	@TransformDate()
	queuedAt!: Date;
	@TransformDate()
	completedAt?: Date;
	status!: ReportJobStatusEnum;
	statusMessage?: string;
	file?: FileDto;
}
